import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import TermsOfService from "./pages/TermsOfService";
import "./pages/styles.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
};

export default App;
